import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { resolveContent } from '@nu-art/ts-common';
export const VirtualizedList = ({ height, width, listToRender, itemHeight, selectedItem, className, omitWrapper }) => {
    const listRef = React.useRef();
    React.useEffect(() => {
        if (selectedItem) {
            listRef.current.scrollToItem(selectedItem, 'center');
        }
    }, [selectedItem, listToRender]);
    function ItemWrapper({ index, style }) {
        if (omitWrapper)
            return resolveContent(listToRender[index], style);
        return _jsx("div", { style: style, children: resolveContent(listToRender[index], style) });
    }
    return (_jsx(List, { ref: listRef, itemSize: itemHeight, height: height, width: width, itemCount: listToRender.length, className: className, itemKey: index => index, children: ItemWrapper }));
};
export const TS_VirtualizedList = (props) => {
    return (_jsx(AutoSizer, { children: (size) => _jsx(VirtualizedList, { className: props.className, selectedItem: props.selectedItem, itemHeight: props.itemHeight, listToRender: props.listToRender, height: props.height ?? size.height, width: size.width }) }));
};
//# sourceMappingURL=TS_VirtualizedList.js.map